import React from "react";
import "./feelSpecial.css";
import Button from "../common/Button";

const FeelSpecial = () => {
  return (
    <div className="feel-special photo-section">
      <div className="max-width">
        <div className="photo-section-child">
          <div className="photo-section-top">
            <div className="photo-section-heading">
            grow your money, the smart way.
            </div>
            <div className="photo-section-subheading">
            AI that helps you invest better
            </div>
          </div>
          <div className="photo-section-bottom">
            <div className="photo-section-desc">
            our system tracks markets 24/7, finds good opportunities,
and helps you make smarter investment decisions.
with crosswalk, your money works smarter.
            </div>
            {/* <div>
              <Button buttonText="Explore Services" />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeelSpecial;
